import { IMLesson, IMModelingPrompt, IMModelingTask } from '../types'
import { createNodeList } from '../../nodeCreationHelpers'
import { snakeKabobToTitleCase } from '../../../utility'
import { wrapB } from '../../html_utility'
import { parseStandardsGroup } from './standards'
import { requiredPreparation } from './ancillary_content'
import { IM360Parser } from './IM360Parser'
import { createDocumentNode } from './createNodeWrappers'

export function parseModelingPrompts(
  lesson: IMLesson,
  modelingPrompts: IMModelingPrompt[],
) {
  const ancestorMatch = (modelingPrompt: IMModelingPrompt) => {
    if (!Object.keys(modelingPrompt).length) return false
    if (!modelingPrompt.references) {
      return firstLesson(lesson)
    }
    const reference = modelingPrompt.references.find(
      ({ type }) => type === 'Lesson',
    )!
    return reference.slug === lesson.slug && reference.title === lesson.title
  }
  const modelingPrompt = modelingPrompts.find(ancestorMatch)
  if (!modelingPrompt) return []
  return [parseModelingPrompt(lesson, modelingPrompt)]
}

function firstLesson(lesson: IMLesson) {
  return lesson.slug === 'lesson-1' && lesson.ancestors.unit.slug === 'unit-1'
}

function parseModelingPrompt(
  lesson: IMLesson,
  modelingPrompt: IMModelingPrompt,
) {
  const noteTitle = snakeKabobToTitleCase(
    `Use After ${lesson.ancestors.unit.ordinal_title}, ${lesson.ordinal_title}`,
  )
  return createNodeList(
    {
      title: 'Modeling Prompts',
    },
    [
      createDocumentNode(modelingPrompt.title, [
        IM360Parser.getInstance().createNoteNode({
          title: noteTitle,
          value: modelingPrompt.in_class_launch,
          studentFacing: false,
        }),
        ...parseStandardsGroup(
          modelingPrompt.standards,
          modelingPrompt.ancillary_content,
        ),
        ...requiredPreparation(modelingPrompt?.ancillary_content ?? {}),
        ...(modelingPrompt.modeling_tasks ?? []).map(parseModelingTask),
      ]),
    ],
  )
}

function parseModelingTask(task: IMModelingTask) {
  return IM360Parser.getInstance().createShortResponse({
    title: task.ordinal_title,
    description: task.statement,
    teacherNote:
      wrapB('Teacher Instructions') +
      task.teacher_instructions +
      wrapB('Sample Response') +
      task.sample_response,
  })
}
